import { isNil } from 'lodash';
import type { ApiResponse } from '../types';
import { apiDataResponseMapper } from 'src/shared/api/utils';
import type { LoginResponse, SSOLoginResponse } from './types';

export const loginResponseMapper = (res: ApiResponse): LoginResponse => {
  const { is2FaEnabled, ...mappedData } = apiDataResponseMapper<
    Record<string, unknown>,
    LoginResponse & { is2FaEnabled?: boolean }
  >(res.data);

  if (!isNil(is2FaEnabled)) {
    mappedData.is2FAEnabled = is2FaEnabled;
  }

  return mappedData;
};

export const ssoLoginResponseMapper = (res: ApiResponse) => {
  const mappedData: SSOLoginResponse = {
    name: res.data.name,
    accessToken: res.data.access_token,
    refreshToken: res.data.refresh_token,
    loginMode: res.data.login_mode,
  };
  return mappedData;
};
